import type { SvgIconPropsWithChildren } from '../components/SvgIcon/index.js';

import React, { createElement } from 'react';

import { SvgIcon } from '../components/SvgIcon/index.js';

function SvgNotificationNumber(props: SvgIconPropsWithChildren) {
  return createElement(
    SvgIcon,
    props,
    <svg viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3736_40162)">
        <path
          d="M24 12.571C24 19.1985 18.6274 24.571 12 24.571C5.37258 24.571 0 19.1985 0 12.571C0 5.94363 5.37258 0.571045 12 0.571045C18.6274 0.571045 24 5.94363 24 12.571Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 23.571C18.0751 23.571 23 18.6462 23 12.571C23 6.49591 18.0751 1.57104 12 1.57104C5.92487 1.57104 1 6.49591 1 12.571C1 18.6462 5.92487 23.571 12 23.571ZM12 24.571C18.6274 24.571 24 19.1985 24 12.571C24 5.94363 18.6274 0.571045 12 0.571045C5.37258 0.571045 0 5.94363 0 12.571C0 19.1985 5.37258 24.571 12 24.571Z"
          fill="currentColor"
        />
        <path
          d="M10.9863 12.4939H12.1113C12.5488 12.4939 12.9108 12.4184 13.1973 12.2673C13.4889 12.1163 13.7051 11.908 13.8457 11.6423C13.9863 11.3767 14.0566 11.072 14.0566 10.7283C14.0566 10.3689 13.9915 10.0616 13.8613 9.8064C13.7363 9.54598 13.5436 9.34546 13.2832 9.20483C13.028 9.06421 12.7025 8.9939 12.3066 8.9939C11.9733 8.9939 11.6712 9.0616 11.4004 9.19702C11.1348 9.32723 10.9238 9.51473 10.7676 9.75952C10.6113 9.9991 10.5332 10.2856 10.5332 10.6189H8.64258C8.64258 10.0147 8.80143 9.47827 9.11914 9.00952C9.43685 8.54077 9.86914 8.17358 10.416 7.90796C10.9681 7.63713 11.5879 7.50171 12.2754 7.50171C13.0098 7.50171 13.6504 7.6241 14.1973 7.8689C14.7493 8.10848 15.179 8.46785 15.4863 8.94702C15.7936 9.42619 15.9473 10.0199 15.9473 10.7283C15.9473 11.0512 15.8717 11.3793 15.7207 11.7126C15.5697 12.046 15.3457 12.3507 15.0488 12.6267C14.752 12.8975 14.3822 13.1189 13.9395 13.2908C13.4967 13.4574 12.9837 13.5408 12.4004 13.5408H10.9863V12.4939ZM10.9863 13.9626V12.9314H12.4004C13.0671 12.9314 13.6348 13.0095 14.1035 13.1658C14.5775 13.322 14.9629 13.5382 15.2598 13.8142C15.5566 14.085 15.7728 14.3949 15.9082 14.7439C16.0488 15.0929 16.1191 15.4626 16.1191 15.8533C16.1191 16.3845 16.0228 16.8585 15.8301 17.2751C15.6426 17.6866 15.3743 18.0356 15.0254 18.322C14.6764 18.6085 14.2676 18.8246 13.7988 18.9705C13.3353 19.1163 12.8301 19.1892 12.2832 19.1892C11.7936 19.1892 11.3249 19.1215 10.877 18.9861C10.429 18.8507 10.028 18.6501 9.67383 18.3845C9.31966 18.1137 9.03841 17.7778 8.83008 17.3767C8.62695 16.9705 8.52539 16.5017 8.52539 15.9705H10.4082C10.4082 16.309 10.4863 16.6085 10.6426 16.8689C10.804 17.1241 11.028 17.3246 11.3145 17.4705C11.6061 17.6163 11.9395 17.6892 12.3145 17.6892C12.7103 17.6892 13.0514 17.6189 13.3379 17.4783C13.6243 17.3376 13.8431 17.1293 13.9941 16.8533C14.1504 16.5772 14.2285 16.2439 14.2285 15.8533C14.2285 15.4106 14.1426 15.0512 13.9707 14.7751C13.7988 14.4991 13.554 14.296 13.2363 14.1658C12.9186 14.0304 12.5436 13.9626 12.1113 13.9626H10.9863Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3736_40162">
          <rect
            width={24}
            height={24}
            fill="white"
            transform="translate(0 0.571045)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export default SvgNotificationNumber;
